import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlobResponse } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class ShipmentBOLDocumentService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('ShipmentBOLDocument');
	}
	
	loadAllForShipment(shipID: System.Guid) : Observable<TooBig4Car.Logic.ShipmentBOLDocument[]> {
		return this.myBaseService.loadAll(this.url + '/'+ (shipID ?? ''));
	}
	
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	
	downloadDoc(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/Content/' + id);
	}
	
}
				
